import {
  Card,
  CardContent,
  Grid,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ERROR, GET } from "../../utils/constants";
import { IAlert } from "../../interfaces/alert";
import { fetchData } from "../../utils/dataProvider";
import AuditWrapper from "../../components/orders/audit/AuditWrapper";
import AuditHistoryTable from "../../components/orders/audit/AuditHistoryTable";
import { useParams } from "react-router-dom";
import { mongoTimeStampToString } from "../../utils/orders";
import { UserContext } from "../../contexts/userContext";
import { IQuoteAudit } from "../../interfaces/order";
import { AUDIT_TAB_VALUES } from "../../components/tabs/AuditsTabs";

const QuoteAudit = () => {
  const { trackingNumber } = useParams();
  const { marketplaceIntegrations }: any = useContext(UserContext);
  const [audit, setAudit] = useState({} as IQuoteAudit);
  const [alert, setAlert] = useState({} as IAlert);
  const [loading, setLoading] = useState(true);

  const getMerchantNameFromId = (id: number) =>
    marketplaceIntegrations.integrations.find(
      ({ merchant: { id: integrationId } }: any) => id === integrationId
    )?.merchant.entity.name;

  const getAudit = async () => {
    setLoading(true);
    try {
      const response = await fetchData({
        url: `/orders/audit/quotes/${trackingNumber}`,
        method: GET,
      });
      setAudit(response);
    } catch (error: any) {
      setAlert({ typeOfAlert: ERROR, message: error, showAlert: true });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAudit();
  }, []);

  return (
    <AuditWrapper loading={loading} alert={alert} tabName={AUDIT_TAB_VALUES.QUOTES}>
      <Grid container xs={12} lg={12}>
        <Grid item xs={12} mb={1.25}>
          <Card className="br-10 bg-light" sx={{ width: "100%" }}>
            <CardContent sx={{ padding: "20px" }}>
              <Grid container spacing={{ xs: 2, md: 0 }}>
                <Grid item xs={6} md={4}>
                  <Typography className="text-bold m-t-10" fontSize={14}>
                    Fecha
                  </Typography>
                  <Typography fontSize={14}>
                    {mongoTimeStampToString(audit.createdAt)}
                  </Typography>
                </Grid>
                {marketplaceIntegrations.integrations && (
                  <Grid item xs={12} md={4}>
                    <Typography className="text-bold m-t-10" fontSize={14}>
                      Merchant
                    </Typography>
                    <Typography fontSize={14}>
                      {getMerchantNameFromId(audit.merchant_id)}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <AuditHistoryTable
              title="Request Completo"
              columns={[{ label: "Request" }, { label: "" }]}
              renderEntries={() => (
                <>
                  {audit?.input && (
                    <TableRow key="input-complete">
                      <TableCell>
                        <pre style={{ margin: 0, fontSize: "12px" }}>
                          <code>{JSON.stringify(audit.input, null, 2)}</code>
                        </pre>
                      </TableCell>
                    </TableRow>
                  )}
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <AuditHistoryTable
              title="Response Completo"
              columns={[{ label: "Responses" }, { label: "" }]}
              renderEntries={() => (
                <>
                  {audit?.responses && (
                    <TableRow key="input-complete">
                      <TableCell>
                        <pre
                          style={{
                            fontSize: "12px",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-all",
                          }}
                        >
                          <code>
                            {JSON.stringify(audit.responses, null, 2)}
                          </code>
                        </pre>
                      </TableCell>
                    </TableRow>
                  )}
                </>
              )}
            />
          </Grid>
        </Grid>
      </Grid>
    </AuditWrapper>
  );
};

export default QuoteAudit;
